<template>
  <p>{{ item.username }}</p>
</template>

<script>
export default {
  name: 'UserTemplate',
  props: {
    item: Object
  }
}
</script>
